// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__N15rJ","header":"Messages_header__37xHl"};